<template>
  <div class="admin-localizacoes">
    <!-- Cabeçalho -->
    <header class="header">
      <h1 class="titulo">📍 Localizações Cadastradas</h1>
    </header>

    <!-- Filtros -->
    <div class="filtro-box">
      <input
        v-model="busca"
        type="text"
        placeholder="Buscar por nome..."
        class="input-busca"
      />

      <button @click="$router.push({ name: 'CadastrarLocalizacao' })" class="btn-principal">
        <i class="fas fa-plus"></i> Nova Localização
      </button>
    </div>

    <!-- Loading -->
    <div v-if="loading" class="loading-state">
      <div class="spinner"></div>
      <p>Carregando registros...</p>
    </div>

    <!-- Nenhum registro -->
    <div v-else-if="localizacoesFiltradas.length === 0" class="empty-state">
      <i class="fas fa-map-marker-alt empty-icon"></i>
      <h3>Nenhuma localização encontrada</h3>
      <p>Tente outro termo de busca.</p>
    </div>

    <!-- Lista -->
    <div v-else class="localizacoes-list">
      <div
        v-for="loc in localizacoesFiltradas"
        :key="loc.id"
        class="local-card"
      >
        <div class="card-header">
          <h3 class="nome">{{ loc.nome }}</h3>
        </div>

        <div class="card-body">
          <p><i class="fas fa-map-pin"></i> Latitude: {{ loc.latitude }}</p>
          <p><i class="fas fa-map-pin"></i> Longitude: {{ loc.longitude }}</p>
          <p><i class="fas fa-ruler"></i> Raio: {{ loc.raio_m }} metros</p>
        </div>

        <div class="card-footer">
          <button class="btn-acao" @click="abrirAtribuicao(loc)">
            <i class="fas fa-users"></i> Atribuir Funcionários
          </button>

          <button class="btn-secundario" @click="abrirModalFuncionarios(loc)">
            <i class="fas fa-eye"></i> Ver Funcionários
          </button>

          <button class="btn-secundario" @click="abrirMapa(loc)">
            <i class="fas fa-map"></i> Ver no Mapa
          </button>

          <button class="btn-deletar" @click="excluirLocalizacao(loc.id)">
            <i class="fas fa-trash"></i> Excluir
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Mapa (placeholder) -->
    <transition name="fade">
      <div v-if="mostrarModalMapa" class="modal-overlay" @click.self="fecharModalMapa">
        <div class="modal">
          <button class="modal-close" @click="fecharModalMapa">✕</button>

          <h3 class="modal-title">📍 Ver Localização</h3>
          <p class="modal-subtitle">{{ localSelecionada?.nome }}</p>

          <div class="mapa-container" ref="mapaContainer"></div>

          <p class="coords">
            Lat: {{ localSelecionada?.latitude }} | Lng: {{ localSelecionada?.longitude }} | Raio: {{ localSelecionada?.raio_m }}m
          </p>

          <div class="modal-actions">
            <button class="btn-secundario" @click="fecharModalMapa">Fechar</button>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal Funcionários -->
    <transition name="fade">
      <div
        v-if="mostrarModalFuncionarios"
        class="modal-overlay"
        @click.self="fecharModalFuncionarios"
      >
        <div class="modal">
          <button class="modal-close" @click="fecharModalFuncionarios">✕</button>
          <h3 class="modal-title">👥 Funcionários da localização</h3>
          <p class="modal-subtitle">{{ localSelecionada?.nome }}</p>

          <div v-if="loadingFuncionariosModal" class="loading-inline">
            <div class="spinner small"></div>
            <span>Carregando funcionários...</span>
          </div>

          <div v-else>
            <div v-if="funcionariosLocal.length === 0" class="empty-modal">
              <p>Nenhum funcionário atribuído.</p>
            </div>

            <ul v-else class="funcionarios-list-modal">
              <li v-for="f in funcionariosLocal" :key="f.usuario_id" class="funcionario-row">
                <div>
                  <strong>{{ f.nome }}</strong>
                  <span class="cargo">{{ f.cargo || 'Sem cargo' }}</span>
                </div>
                <button
                  class="btn-deletar pequeno"
                  :disabled="removendoFuncionarioId === f.usuario_id"
                  @click="removerFuncionarioDaLocalizacao(f.usuario_id)"
                >
                  {{ removendoFuncionarioId === f.usuario_id ? 'Removendo...' : 'Remover' }}
                </button>
              </li>
            </ul>
          </div>

          <div class="modal-actions">
            <button class="btn-secundario" @click="fecharModalFuncionarios">Fechar</button>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>
<script>
import { adminService } from '@/services/adminService';
import L from 'leaflet';

export default {
  name: "LocalizacoesList",
  data() {
    return {
      loading: false,
      registros: [],
      busca: "",
      mostrarModalMapa: false,
      mostrarModalFuncionarios: false,
      localSelecionada: null,
      funcionariosLocal: [],
      loadingFuncionariosModal: false,
      removendoFuncionarioId: null,
      mapa: null,
    };
  },

  computed: {
    localizacoesFiltradas() {
      let lista = this.registros;

      if (this.busca.trim()) {
        const termo = this.busca.toLowerCase();
        lista = lista.filter(l => l.nome.toLowerCase().includes(termo));
      }

      return lista;
    },
  },

  methods: {
    async buscarRegistros() {
      this.loading = true;
      try {
        const response = await adminService.listLocalizacoes();
        this.registros = response.data;
      } catch (err) {
        console.error(err);
        alert("Erro ao carregar localizações.");
      } finally {
        this.loading = false;
      }
    },

    abrirAtribuicao(loc) {
      this.$router.push({ name: "AtribuirLocalizacao", params: { id: loc.id } });
    },

    abrirMapa(loc) {
      this.localSelecionada = loc;
      this.mostrarModalMapa = true;
      this.$nextTick(() => {
        this.renderizarMapa();
      });
    },

    async abrirModalFuncionarios(loc) {
      this.localSelecionada = loc;
      this.mostrarModalFuncionarios = true;
      await this.carregarFuncionariosLocalizacao(loc.id);
    },

    fecharModalFuncionarios() {
      this.mostrarModalFuncionarios = false;
      this.localSelecionada = null;
      this.funcionariosLocal = [];
    },

    async carregarFuncionariosLocalizacao(localId) {
      this.loadingFuncionariosModal = true;
      try {
        const response = await adminService.listarFuncionariosPorLocalizacao(localId);
        this.funcionariosLocal = response.data;
      } catch (err) {
        console.error(err);
        alert("Erro ao carregar funcionários da localização.");
      } finally {
        this.loadingFuncionariosModal = false;
      }
    },

    async removerFuncionarioDaLocalizacao(usuarioId) {
      if (!this.localSelecionada) return;
      const confirmar = confirm("Deseja remover este funcionário desta localização?");
      if (!confirmar) return;

      this.removendoFuncionarioId = usuarioId;
      try {
        await adminService.removerFuncionarioDaLocalizacao(this.localSelecionada.id, usuarioId);
        await this.carregarFuncionariosLocalizacao(this.localSelecionada.id);
      } catch (err) {
        console.error(err);
        alert("Erro ao remover funcionário.");
      } finally {
        this.removendoFuncionarioId = null;
      }
    },

    renderizarMapa() {
      if (!this.localSelecionada) return;

      const center = [this.localSelecionada.latitude, this.localSelecionada.longitude];

      if (this.mapa) {
        this.mapa.remove();
        this.mapa = null;
      }

      this.mapa = L.map(this.$refs.mapaContainer, {
        zoomControl: true,
        scrollWheelZoom: true,
      }).setView(center, 16);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; OpenStreetMap contributors'
      }).addTo(this.mapa);

      L.marker(center).addTo(this.mapa).bindPopup(this.localSelecionada.nome);

      L.circle(center, {
        radius: this.localSelecionada.raio_m,
        color: '#0ea5e9',
        fillColor: '#0ea5e9',
        fillOpacity: 0.15
      }).addTo(this.mapa);
    },

    fecharModalMapa() {
      this.mostrarModalMapa = false;
      this.localSelecionada = null;
      if (this.mapa) {
        this.mapa.remove();
        this.mapa = null;
      }
    },

    async excluirLocalizacao(id) {
      const confirmar = confirm("Deseja realmente excluir esta localização?");
      if (!confirmar) return;

      try {
        await adminService.deletarLocalizacao(id);
        alert("Localização excluída!");
        this.buscarRegistros();
      } catch (err) {
        console.error(err);
        alert("Erro ao excluir.");
      }
    },
  },

  mounted() {
    this.buscarRegistros();
  },
};
</script>
<style scoped>
.admin-localizacoes {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem 1rem;
  background: #f8fafc;
  min-height: 100vh;
  font-family: 'Inter', sans-serif;
}

.header { text-align: center; margin-bottom: 1rem; }
.titulo { font-size: 1.5rem; font-weight: 700; color: #1e293b; }

.filtro-box {
  display: flex;
  flex-wrap: wrap;
  gap: .5rem;
  margin-bottom: 1.2rem;
  justify-content: space-between;
}

.input-busca {
  flex: 1;
  min-width: 200px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 0.7rem 0.9rem;
  font-size: 1rem;
}

.btn-principal {
  background: linear-gradient(120deg, #2563eb, #1d4ed8);
  color: white;
  border: none;
  padding: .65rem 1rem;
  border-radius: 10px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: .45rem;
  box-shadow: 0 6px 14px rgba(37, 99, 235, 0.18);
  cursor: pointer;
}

.localizacoes-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.local-card {
  background: white;
  border-radius: 12px;
  padding: 1rem 1.2rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.card-header { margin-bottom: .6rem; }
.nome { font-weight: 700; color: #1e293b; }

.card-body { color: #334155; font-size: 0.9rem; }
.card-body p { margin: .2rem 0; }

.card-footer {
  display: flex;
  gap: .5rem;
  margin-top: .8rem;
  justify-content: flex-end;
}

.btn-acao {
  background: #10b981;
  color: white;
  border: none;
  padding: .5rem .8rem;
  border-radius: 8px;
  font-weight: 600;
}

.btn-secundario {
  background: #e2e8f0;
  border: none;
  padding: .5rem .8rem;
  border-radius: 8px;
  font-weight: 600;
}

.btn-deletar {
  background: #ef4444;
  color: white;
  border: none;
  padding: .5rem .8rem;
  border-radius: 8px;
  font-weight: 600;
}

/* Modal */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: white;
  padding: 1.5rem;
  border-radius: 16px;
  max-width: 400px;
  width: 100%;
  position: relative;
}

.modal-title {
  font-size: 1.2rem;
  margin-bottom: .5rem;
}

.modal-subtitle {
  color: #475569;
  margin-bottom: .8rem;
}

.mapa-container {
  height: 280px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  margin-bottom: .6rem;
}

.coords {
  color: #475569;
  font-size: .9rem;
  margin-bottom: .5rem;
}

.modal-close {
  position: absolute;
  top: 12px;
  right: 12px;
  background: #e2e8f0;
  border: none;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  font-weight: 700;
  color: #0f172a;
  cursor: pointer;
  display: grid;
  place-items: center;
  transition: background .2s ease, transform .2s ease;
}

.modal-close:hover {
  background: #cbd5e1;
  transform: scale(1.03);
}

.loading-inline {
  display: flex;
  align-items: center;
  gap: .6rem;
  color: #475569;
}

.spinner.small {
  width: 18px;
  height: 18px;
  border: 3px solid #e2e8f0;
  border-top-color: #0ea5e9;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.funcionarios-list-modal {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: .6rem;
}

.funcionario-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .7rem .8rem;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
}

.funcionario-row .cargo {
  display: block;
  color: #64748b;
  font-size: .85rem;
}

.btn-deletar.pequeno {
  padding: .35rem .65rem;
  font-size: .9rem;
}

.empty-modal {
  padding: 1rem;
  text-align: center;
  color: #475569;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

.fade-enter-active, .fade-leave-active { transition: .25s; }
.fade-enter-from, .fade-leave-to { opacity: 0; transform: translateY(10px); }

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
